import { Component, inject } from '@angular/core';
import { LAYOUT_TYPE } from '../../model/common.model';
import { ExcludedRequiredFieldsList, ManageExceptionpaymentReportFilterSchema, ManageExceptionpaymentReportProps, ManageExceptionpaymentReportTableSchema, searchGetConfig } from '../../model/dealer-training-billing-manage-exception-report.model';
import { PageContainerComponent } from '../../layout/page-container/page-container.component';
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE, SearchConfig } from '../../model/api.model';
import { DynamicFormArray, FIELD_TYPES, Props } from '../../model/form.model';
import { BaseComponent } from '../base/base.component';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
import { CommonUtils } from '../../utils/common.utils';
import { FormService } from '../../services/form.service';
import { FormGroup, Validators } from '@angular/forms';
import { FieldNames, PaymentTypeDropdownValues, StatusDropdownValues } from '../../model/form-fields.model';
import { CommonService } from '../../services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../layout/confirmation-dialog/confirmation-dialog.component';
import { LucideBadgeAlert } from '@lucide/angular';

@Component({
  selector: 'app- console.log(event)',
  standalone: true,
  imports: [PageContainerComponent],
  templateUrl: './dealer-billing-manage-exception-report.component.html',
})
export class DealerBillingManageExceptionReportComponent extends BaseComponent {
  protected data = 'DealerBillingManageExceptionReportComponent';
  public dataTableSchema: DataTableSchema = structuredClone(ManageExceptionpaymentReportTableSchema);
  public filterSchema: DynamicFormArray = structuredClone(ManageExceptionpaymentReportFilterSchema);
  protected props: Props = ManageExceptionpaymentReportProps
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  title = "";
  commonUtils = inject(CommonUtils);
  service = inject(CommonService);
  formService = inject(FormService);
  billingForm: FormGroup | undefined;
    loadReportData: any;
  constructor(readonly dialog: MatDialog) {
    super();
  }
  override ngOnInit() {
    super.ngOnInit();
    super.commonFunction();
    this.getOnLoadData();
    this.addRequiredValidatorToFields();
    this.disableEnableButtons(true);
    this.formService.form$.subscribe(form => {
      this.billingForm = form;
      this.dynamicFieldValidation(form);
    });
  }
  addRequiredValidatorToFields() {
    this.filterSchema.FieldsArray.forEach(field => {
      if (!ExcludedRequiredFieldsList.includes(field.fieldName)) {
        field.required = true;
      }
    });
  }
  getOnLoadData() {
    const searchParam: SearchConfig = searchGetConfig;
    this.setTableLoadingState(true);
    this.service.getDataFromDataSource(searchParam, ApiEnvNames['DealerTrainingBilling']).then(response => {
      if (response['status'] === API_STATUS['Success']) {
        if (Array.isArray(response.result)) {
          this.dataTableSchema.dataSource = response.result;
        }
      }
      this.setTableLoadingState(false);
    }).catch(err => {
      console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);
      this.setTableLoadingState(false);
    })
  };


  override  onSearchClicked = (searchParam: SearchConfig) => {
    this.openDialog(searchParam);
  };
  openDialog(searchParam: SearchConfig) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: "This will create the request for exception payment, Do you wish to continue?",
        header: "Confirm Exception Payment Creation",
        icon: LucideBadgeAlert
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.insertIntoDb(searchParam);

      }
    });
  }

  insertIntoDb = (searchParam: SearchConfig) => {
    this.setTableLoadingState(true);
    this.commonUtils.spinner('show');
    this.filterSchema['FieldsArray'].forEach(field => {
      if (field['selectedValue'] && field['selectedValue'] !== null && field['selectedValue'] !== '') {
        searchParam['body'][field['fieldName']] = field['selectedValue']
      } else if (field['fieldType'] === FIELD_TYPES.NUMBER) {
        searchParam['body'][field['fieldName']] = null;
      }
    });
    if (this.service.loggedUserDetails) {
          searchParam['body']['addedBy'] = this.service.loggedUserDetails['workdayId'];
          searchParam['body']['addedByUser'] = this.service.loggedUserDetails['userName'];
    }
    this.service.getDataFromDataSource(searchParam, ApiEnvNames['DealerTrainingBilling']).then(response => {
      if (response['status'] === API_STATUS['Success']) {
        this.commonUtils.showMatSnackBar("Exception payment created successfully");
        this.getOnLoadData();
        this.onResetClicked();
      } else {
        this.commonUtils.spinner('hide');
        this.commonUtils.showMatSnackBar("Failed to create exception payment");
      }
      this.commonUtils.spinner('hide');
      this.setTableLoadingState(false);
    }).catch(err => {
      console.info(err);
       this.commonUtils.showMatSnackBar("Failed to create exception payment");
      this.setTableLoadingState(false);
    }).finally(() => {
      this.commonUtils.spinner('hide');
    })

  }

  override onResetClicked = () => {
    this.filterSchema.FieldsArray = this.filterSchema.FieldsArray.map((field) => ({ ...field, selectedValue: '' }));
    this.resetSorting()
    this.disableEnableButtons(true);
    this.billingForm?.reset();
  };

  dynamicFieldValidation(form: FormGroup) {
    form.get(FieldNames.Status)?.valueChanges.subscribe(value => {
      const dynamicFieldName = FieldNames.CompletionDate;
      const control = form.get(dynamicFieldName);
      if (control) {
        if (value === StatusDropdownValues[0].fieldValue) {
          control.setValidators([Validators.required]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    });
    form.get(FieldNames.PaymentType)?.valueChanges.subscribe(value => {
      const dynamicFieldNameList = [FieldNames.SpinId, FieldNames.FirstName, FieldNames.LastName];
      dynamicFieldNameList.forEach((field: any) => {
        const control = form.get(field);
        if (control) {
          if (value === PaymentTypeDropdownValues[1].fieldValue) {
            control.setValidators([Validators.required]);
          } else {
            control.clearValidators();
          }
          control.updateValueAndValidity();
        }
      })

    });
  }

}

